import { FuseAnimate } from "@fuse";
import { Table, TableBody, TableCell, TableHead, TableRow, TextField, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import EvolucaoExameEdit from "./EvolucaoExameEdit";

const styles = theme => ({
    cell: {
        borderColor: theme.palette.divider,
        padding: "2px 12px"
    },
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

const NewState = {
    open: null,
    coluna: [],
    linha: [],
    data: [],
    focus: null,
};

class EvolucaoExame extends XAPPComponent {

    state = { ...NewState };

    componentDidUpdate(prevProps, prevState) {
        const { formulario = null, onChange } = this.props;
        if (!_.isEqual(prevState.data, this.state.data)) {
            onChange({ target: { name: "evolucao", value: this.state } });
        }

        if (!_.isNull(formulario?.evolucao) && formulario.evolucao.data?.length > 0 && this.state.data.length < 1) {
            this.setState({ ...formulario.evolucao });
        }

    }

    getColumns = () => {
        const { coluna = [] } = this.state;
        return coluna;
    };

    getRows = () => {
        const { linha = [] } = this.state;
        return _.orderBy(linha, "name", "desc");
    };

    getData = (_ACol, _ARow) => {
        const { data = [] } = this.state;
        return _.find(data, x => x.col === _ACol && x.row === _ARow);
    };

    openDialog = (_AValue = null) => {
        this.setState(_.set({ ...this.state }, "open", !_.isNull(_AValue) ? { ..._AValue, id: _AValue.id ?? new Date().getTime() } : null));
    };

    editElement = (_ATipo = "linha", _AValue) => {
        const ATmp = Object.assign([], this.state[_ATipo]);
        delete _AValue.tipo;
        const AIndex = _.findIndex(ATmp, x => x.id === _AValue.id);
        if (AIndex > -1) {
            ATmp.splice(AIndex, 1);
        }
        ATmp.push(_AValue);
        let AState = Object.assign({}, this.state);
        AState[_ATipo] = ATmp;
        this.setState(_.set({ ...AState }, "open", null));
    };

    setFocus = _AValue => {
        this.setState(_.set({ ...this.state }, "focus", _AValue));
    };

    removeElement = _AID => {
        const ATmp = Object.assign([], this.state);
        ["coluna", "linha"].forEach(chave => {
            const AIndex = _.findIndex(ATmp[chave], x => x.id === _AID);
            if (AIndex > -1) {
                ATmp[chave].splice(AIndex, 1);
            }
        });
        ATmp.data.forEach((item, index) => {
            if (item.col === _AID || item.row === _AID) {
                ATmp.data.splice(index, 1);
            }
        });
        this.setState(_.set({ ...ATmp }, "open", null));
    };

    render() {
        const { classes, formulario, onChange } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                <div>
                    <TextField
                        className="mb-12 w-full"
                        label="Descrição"
                        id="descricao"
                        name="descricao"
                        value={formulario.descricao}
                        onChange={onChange}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>
                <div className="overflow-x-auto">
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <Table className="min-w-full" aria-labelledby="tableTitle">
                            <TableHead>
                                <TableRow className="h-48">
                                    <TableCell key={"default"} className={clsx("border-r-1", classes.cell)}></TableCell>
                                    {this.getColumns().map(col => (
                                        <TableCell
                                            key={col.id}
                                            align={"center"}
                                            className={clsx("cursor-pointer relative border-r-1 whitespace-no-wrap min-w-224", classes.cell)}
                                            onClick={() => this.openDialog({ ...col, "tipo": "coluna" })}
                                            onMouseLeave={() => this.setFocus(null)}
                                            onMouseEnter={() => this.setFocus(col.id)}
                                        >
                                            {col.name}
                                            {!_.isNull(form.focus) && form.focus === col.id &&
                                                <div className="absolute right-0 top-0">
                                                    <ConfirmacaoApp
                                                        id={"Delete_" + col.id}
                                                        type="icon"
                                                        tooltip={{ title: "Remover exame", placement: "top" }}
                                                        icon={"delete"}
                                                        mensagem="Ao excluir esta coluna, todos os dados dela serão removidos. Confirma a exclusão?"
                                                        onConfirmation={ev => {
                                                            ev.stopPropagation();
                                                            this.removeElement(col.id);
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </TableCell>
                                    ))}
                                    <TableCell key={"add"} className={clsx("w-128", classes.cell)}>
                                        <XAPPButton
                                            type="Button"
                                            className=""
                                            variant="outlined"
                                            onClick={() => this.openDialog({ "tipo": "coluna" })}
                                            label={"exame"}
                                            icon="add"
                                            iconProps="mr-8"
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getRows().map((row, x) => (
                                    <TableRow key={"row-" + x} className={clsx("", x % 2 === 0 && classes.anotherLine)}>
                                        <TableCell
                                            key={"col-" + row.id}
                                            className={clsx("cursor-pointer relative border-r-1 w-128", classes.cell)}
                                            component="th"
                                            scope="row"
                                            onClick={() => this.openDialog({ ...row, "tipo": "linha" })}
                                            onMouseLeave={() => this.setFocus(null)}
                                            onMouseEnter={() => this.setFocus(row.id)}
                                        >
                                            {dayjs(row.name).format("DD/MM/YYYY")}
                                            {!_.isNull(form.focus) && form.focus === row.id &&
                                                <div className="absolute right-0 top-0">
                                                    <ConfirmacaoApp
                                                        id={"Delete_" + row.id}
                                                        type="icon"
                                                        tooltip={{ title: "Remover evolução", placement: "top" }}
                                                        icon={"delete"}
                                                        mensagem="Ao excluir esta linha, todos os dados dela serão removidos. Confirma a exclusão?"
                                                        onConfirmation={ev => {
                                                            ev.stopPropagation();
                                                            this.removeElement(row.id);
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </TableCell>
                                        {this.getColumns().map((col, y) => {
                                            return (
                                                <TableCell
                                                    key={"col-" + y}
                                                    component="th"
                                                    scope="row"
                                                    align={col.align}
                                                    className={clsx("cursor-pointer border-r-1", classes.cell)}
                                                >
                                                    <TextField
                                                        className="w-full"
                                                        id="detalhe"
                                                        name="detalhe"
                                                        value={this.getData(col.id, row.id)?.detalhe ?? ""}
                                                        onChange={ev => this.editElement("data", { "detalhe": ev.target.value, "col": col.id, "row": row.id, "tipo": "data", "id": this.getData(col.id, row.id)?.id ?? new Date().getTime() })}
                                                        fullWidth
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell key={"col-blank"} component="th" scope="row">
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow key={"row-add"} className={clsx("")}>
                                    <TableCell key={"add-btn"} className={clsx("border-r-1 w-128", classes.cell)} component="th" scope="row">
                                        <XAPPButton
                                            type="Button"
                                            className=""
                                            variant="outlined"
                                            onClick={() => this.openDialog({ "tipo": "linha" })}
                                            label={"evolução"}
                                            icon="add"
                                            iconProps="mr-8"
                                        />
                                    </TableCell>
                                    <TableCell key={"col-blank"} colSpan={this.getColumns().length + 1} component="th" scope="row">
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </FuseAnimate>
                </div>
                <EvolucaoExameEdit
                    open={form.open}
                    onClose={this.openDialog}
                    editElement={this.editElement}
                />
            </React.Fragment>

        );
    }
}


export default withStyles(styles, { withTheme: true })(EvolucaoExame);
